import { parseDateTime } from '@Utils/transformDateTime';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { AttendanceProfileResponse } from '@Types/api/profile/AttendanceProfileList';
import { ColumnDataType } from './type';

export const attendanceMapper = (
  data: AttendanceProfileResponse
): ColumnDataType => ({
  key: `${data.InTime + data.OutTime + data.AttDate}`,
  date: parseDateTime(data.AttDate) || EMPTY_FIELD_PLACEHOLDER,
  inTime: data.InTime || EMPTY_FIELD_PLACEHOLDER,
  outTime: data.OutTime || EMPTY_FIELD_PLACEHOLDER,
  remarks: data.Remarks || EMPTY_FIELD_PLACEHOLDER,
  createButton: Boolean(data.Createbtn),
  actions: '',
});

export const attendanceProfileDataSourceMap = (
  // eslint-disable-next-line
  data: Array<AttendanceProfileResponse> | null | undefined
): Array<ColumnDataType> => {
  if (data == null) return [];
  return data.map(attendanceMapper);
};
